<template>
  <b-row>
    <b-col sm="4" md="4" lg="4" style=" border-right: 2px solid white;">
      <h2 align="center"><b>Ingreso</b></h2>
      <br />

      <div class="d-flex justify-content-center">
        <b-button
          @click="selectOption"
          class="btn btn-sm btnClass"
          style="background-color: #ff4da9; color:white"
        >
          Peritos
        </b-button>
        <b-button
          class="btn btn-sm btnClass"
          style="background-color: #660033; color:white"
        >
          Asignación
        </b-button>
      </div>
      <br />
      <h5><b>Peritos</b></h5>
      <div>
        <b-form-select v-model="schema.selected" class="mb-3">
          <b-form-select-option
            :value="item.id"
            v-for="(item, i) in getPeritos"
            :key="i"
            >{{ item.Nombre }}</b-form-select-option
          >
        </b-form-select>
        <br />
        <b-form-checkbox
          v-model="schema.checked"
          name="check-button"
          switch
          style="margin-left:30px;"
        >
          Selección Aleatoria
        </b-form-checkbox>
        <br />
      </div>
      <div v-for="(item, i) in forForm" :key="i">
        <b-form-input
          :id="getId(item.state)"
          :state="item.state"
          v-model="schema[item.title]"
          :placeholder="item.title"
        ></b-form-input>
        <br />
      </div>

      <b-button @click="modalShow = !modalShow">Selecciona una ubicación</b-button>
      <br />
      <br />
      <div class="d-flex justify-content-center">
        <b-button
          class="btn btn-lg btnLgClass "
          style=" color:white"
          v-on:click="saveAsignacionData()"
        >
          Crear Asignación
        </b-button>
      </div>
    </b-col>
    <b-col sm="8" md="8" lg="8">
      <h2><b>Asignaciones</b></h2>
      <b-row>
        <b-col sm="6" md="6" lg="6">
          <b-form-group
            label-for="filter-input"
            label-align-sm="right"
            class="mb-0"
          >
            <b-input-group>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Escribe aqui para buscar"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Limpiar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />

      <div>
        <b-table
          striped
          hover
          :items="getAsignacion"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="fields"
          responsive
          v-loading="tableLoading"
        ></b-table>
      </div>
    </b-col>
    <!-- <pre>{{ schema }}</pre> -->
    <!-- <pre>{{ getAsignacion }}</pre> -->

    <!-- <b-button @click="modalShow = !modalShow">Open Modal</b-button> -->

    <b-modal v-model="modalShow" size="lg">
      <GmapMap
        :center="center"
        :zoom="18"
        map-style-id="roadmap"
        :options="mapOptions"
        style="width: 75vmin; height: 50vmin"
        ref="mapRef"
        @click="handleMapClick"
      >
        <GmapMarker
          :position="marker.position"
          :clickable="true"
          :draggable="true"
          @drag="handleMarkerDrag"
          @click="panToMarker"
        />
      </GmapMap>
      <button @click="geolocate">Detectar Ubicación</button>

      <p>Posición Seleccionada: {{ marker.position }}</p>
    </b-modal>
  </b-row>
</template>
<script>
export default {
  name: "asignaciones",
  props: ["selectOption"],
  data() {
    return {
      modalShow: false,
      formLoading: false,
      tableLoading: false,
      filter: null,
      schema: {
        checked: true,
        selected: null,
        location: {}
      },

      fields: [
        "perito",
        "cliente",
        "numAsignacion",
        "tipoAvaluo",
        "estado",
        "valorMercado",
        "ciudad",
        "valorRealizacion",
        "oficialCuenta",
        "location"
      ],
      forForm: [
        {
          title: "cliente",
          state: null
        },
        {
          title: "numAsignacion",
          state: null
        },
        {
          title: "tipoAvaluo",
          state: null
        },
        {
          title: "estado",
          state: null
        },
        {
          title: "valorMercado",
          state: null
        },
        {
          title: "ciudad",
          state: null
        },
        {
          title: "valorRealizacion",
          state: null
        },
        {
          title: "oficialCuenta",
          state: null
        }
      ],
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: true
      }
    };
  },
  mounted() {
    this.fetchAsignacionData();
    this.geolocate();
  },
  computed: {
    getAsignacion() {
      return this.$store.getters["asignacion/$allAsignacion"];
    },
    getPeritos() {
      return this.$store.getters["asignacion/$allPeritos"];
    }
  },
  methods: {
    fetchAsignacionData() {
      this.tableLoading = true;
      this.$store.dispatch("asignacion/fetchAsignacionData").then(() => {
        this.tableLoading = false;
      });
    },
    saveAsignacionData() {
      this.formLoading = true;
      this.$store
        .dispatch("asignacion/uploadAsignacionData", this.schema)
        .then(() => {
          this.fetchAsignacionData();
          this.formLoading = false;
        });
    },
    getId(state) {
      if (state === null) return "input-none";
      else if (state) return "input-valid";
      else return "input-invalid";
    },
    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition(position => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.panToMarker();
      });
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
      this.$refs.mapRef.setZoom(18);
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = {
        latitud: e.latLng.lat(),
        longitud: e.latLng.lng()
      };
      // console.log(e);
      this.schema.location = {
        latitud: e.latLng.lat(),
        longitud: e.latLng.lng()
      };
    }
  },
  watch: {
    marker(val) {
      console.log("val>>:", val);
      schema.location = val.position;
    }
  }
};
</script>

<style>
.btnClass {
  width: 100px !important;
}
.btnLgClass {
  width: 200px !important;
  background-color: #ff3399;
}
.btnLgClass:hover {
  color: #fff;
  background-color: #ff3399;
}
.table thead th {
  border-right: 1px solid white;
  vertical-align: bottom;
  background-color: rgb(102, 0, 51);
  text-color: white;
  color: white;
  border-bottom: 2px solid #e9ecef;
}
.table td,
.table th {
  font-size: 0.8125rem;
  border-right: 1px solid white;
  white-space: nowrap;
}
</style>
